
<template>
    <li
        v-tooltip="{
            content: label,
            placement: 'right',
            classes: tooltipClasses,
        }"
    >
        <RouterLink
            :to="to"
            class="Link"
            v-bind="attrs"
        >
            <WIcon
                v-if="icon"
                :icon="icon"
                :size="20"
            />
            <Transition
                name="fade"
                mode="out-in"
            >
                <WText
                    v-if="!collapsed"
                    tag="span"
                    weight="semi"
                    :size="14"
                >
                    {{ label }}
                </WText>
            </Transition>
        </RouterLink>

        <ul v-if="children && !collapsed">
            <li
                v-for="({ to: subTo, label: subLabel }, subIndex) in children"
                :key="`navSubLink-${subIndex}`"
            >
                <RouterLink
                    :to="subTo"
                    class="Link secondary"
                >
                    <Transition
                        name="fade"
                        mode="out-in"
                    >
                        <WText
                            v-if="!collapsed"
                            tag="span"
                            weight="semi"
                            :size="12"
                        >
                            {{ subLabel }}
                        </WText>
                    </Transition>
                </RouterLink>
            </li>
        </ul>
    </li>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'NavItems',
    props: {
        to: VueTypes.object,
        attrs: VueTypes.any,
        icon: VueTypes.string.required,
        collapsed: VueTypes.bool.def(true),
        label: VueTypes.string.required,
        children: VueTypes.array,
    },
    computed: {
        tooltipClasses () {
            return [
                'navItems',
                !this.collapsed ? 'hide' : '',
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
ul {
    margin: 0;
    padding: 0;
    width: 100%;
    list-style: none;
}
.Link {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 44px;
    font-size: 14px;
    transition: all 350ms ease;

    @media screen and (min-width: $md) {
        padding: 4px 15px;
    }

    &:hover, &.router-link-active {
        background-color: rgba($accent-blue, .15);
    }

    &[hidden] {
        display: none;
    }

    .WIcon {
        color: $accent-blue;
        margin: 0 15px 0 5px;
    }

    .WText {
        display: block;
        color: $accent-blue;
        line-height: 1.25;
        transition: color .3s ease-out;
    }

    & + ul {
        .Link {
            transition: max-height .3s ease-out, padding .3s ease-out, margin .3s ease-out, opacity .3s ease-out;
            overflow: hidden;
            max-height: 0;
            padding-top: 0;
            padding-bottom: 0;
            opacity: 0;
        }
    }
    &.router-link-active + ul {
        .Link {
            max-height: 36px;
            padding-top: 8px;
            padding-bottom: 8px;
            opacity: 1;
        }
    }

    &.secondary {
        display: block;
        min-height: 0;
        font-size: 14px;
        background-color: transparent;
        text-overflow: ellipsis;
        overflow: hidden;

        .WText {
            margin-left: 10px;
        }

        &:hover, &.router-link-exact-active, &.router-link-active {
            background-color: rgba($accent-blue, .1);
            .WText {
                color: $accent-blue;
            }
        }
    }
}
</style>
